import React from 'react';
import Divider from '@material-ui/core/Divider';
import Dialog from '@material-ui/core/Dialog';
import Avatar from '@material-ui/core/Avatar';
import deepPurple from '@material-ui/core/colors/deepPurple';

import withStyles from '@material-ui/core/styles/withStyles';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  Menu,
  MenuItem,
  Select,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { KeyboardDatePicker } from '@material-ui/pickers';

import { useStyles } from './styles.js';

class HSProfilePopover extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      taskStatus: '',
      taskDetails: '',
      taskSubject: '',
      statusList: [
        {
          key: 'NOT_STARTED',
          value: 'Not Started',
        },
        {
          key: 'IN_PROGRESS',
          value: 'In Progress',
        },
        {
          key: 'COMPLETED',
          value: 'Completed',
        },
        {
          key: 'WAITING',
          value: 'Waiting on someone else',
        },
        {
          key: 'DEFERRED',
          value: 'Deferred',
        },
      ],
      taskDate: new Date(),
    };
  }

  handleClose = () => {
    this.props.onClose();
  };

  createHSLead = () => {
    this.props.createHSLead(
      this.state.taskSubject,
      this.state.taskDetails,
      this.state.taskStatus,
      this.state.taskDate,
    );
  };

  addHSTask() {
    this.props.addHSTask(
      this.state.taskSubject,
      this.state.taskDetails,
      this.state.taskStatus,
      this.state.taskDate,
    );
  }

  handleTextfieldChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleChange(name, value) {
    this.setState({ [name]: value });
  }

  handleDateChange = date => {
    this.setState({ taskDate: date });
  };

  render() {
    const options = [
      'Scheduled',
      'Completed',
      'In Progress',
      'On Hold',
      'Cancelled',
      'Rescheduled-Customer',
      'Rescheduled-Rep',
    ];
    const classes = this.props.classes;

    return (
      <Dialog
        maxWidth="lg"
        fullWidth={true}
        onClose={this.handleClose}
        open={this.props.open}
      >
        {this.props.progress ? (
          <div className={classes.pContainer}>
            <CircularProgress className={classes.progress} />
          </div>
        ) : (
          <Grid
            container
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ padding: '15px 25px' }}
          >
            <Grid container xs={12} sm={12} md={12} lg={12}>
              <Grid
                item
                xs={12}
                sm={2}
                md={2}
                lg={2}
                style={{ textAlign: 'center', marginBottom: '10px' }}
              >
                <Avatar
                  alt="Remy Sharp"
                  style={{
                    width: 60,
                    height: 60,
                    color: '#fff',
                    backgroundColor: deepPurple[500],
                    margin: '0px auto',
                  }}
                >
                  {this.props.response !== undefined &&
                    this.props.response !== null &&
                    this.props.response !== '' &&
                    this.props.response.guest_name &&
                    this.props.response.guest_name.charAt(0)}
                </Avatar>
              </Grid>
              <Grid item xs={12} sm={9} md={9} lg={9}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginBottom: '10px',
                  }}
                >
                  <span style={{ color: 'gray' }}>Name: </span>
                  <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>
                    {this.props.response !== undefined &&
                      this.props.response !== null &&
                      this.props.response !== '' &&
                      this.props.response.guest_name.toUpperCase()}
                  </span>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginBottom: '10px',
                  }}
                >
                  <span style={{ color: 'gray' }}>Email:</span>
                  <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>
                    {this.props.response !== undefined &&
                      this.props.response !== null &&
                      this.props.response !== '' &&
                      this.props.response.guest_email.toLowerCase()}
                  </span>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginBottom: '10px',
                  }}
                >
                  <span style={{ color: 'gray' }}>Company Name:</span>
                  <span style={{ marginLeft: '10px', fontWeight: '400' }}>
                    {this.props.response !== undefined &&
                      this.props.response !== null &&
                      this.props.response !== '' &&
                      this.props.response.guest_company_name !== undefined &&
                      this.props.response.guest_company_name}
                  </span>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginBottom: '10px',
                  }}
                >
                  <span style={{ color: 'gray' }}>Title:</span>
                  <span style={{ marginLeft: '10px', fontWeight: '400' }}>
                    {this.props.response !== undefined &&
                      this.props.response !== null &&
                      this.props.response !== '' &&
                      this.props.response.guest_title !== undefined &&
                      this.props.response.guest_title}
                  </span>
                </div>
              </Grid>
            </Grid>
            <Divider style={{ width: '100%', margin: '20px 0px' }} />
            <Grid container xs={12} sm={12} md={12} lg={12}>
              <Grid
                item
                xs={12}
                sm={2}
                md={2}
                lg={2}
                style={{ textAlign: 'center', marginBottom: '10px' }}
              >
                <img src="/images/hubspot.png" width="125px" />
              </Grid>

              <Grid item xs={12} sm={9} md={9} lg={9}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginBottom: '10px',
                  }}
                >
                  <span style={{ color: 'gray' }}>Status: </span>
                  <div>
                    <span style={{ color: 'green', marginLeft: '10px' }}>
                      <b>
                        {this.props.response !== undefined &&
                          this.props.response !== null &&
                          this.props.response !== '' &&
                          this.props.response.type}
                      </b>
                    </span>
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginBottom: '10px',
                  }}
                >
                  <span style={{ color: 'gray' }}>Rep: </span>
                  <span style={{ marginLeft: '10px' }}>
                    {(this.props.response !== undefined &&
                      this.props.response !== null &&
                      this.props.response !== '' &&
                      this.props.response.rep) ||
                      '-'}
                  </span>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginBottom: '10px',
                  }}
                >
                  <span style={{ color: 'gray' }}>Opportunities: </span>
                  <div style={{ marginLeft: '10px' }}>
                    {this.props.response !== undefined &&
                      this.props.response !== null &&
                      this.props.response !== '' &&
                      this.props.response.oppCount}
                  </div>
                </div>

                <div style={{ marginBottom: '10px' }}>
                  <span style={{ color: 'gray' }}>Product: </span>
                  {this.props.response !== undefined &&
                  this.props.response !== null &&
                  this.props.response !== '' &&
                  this.props.response.product !== undefined &&
                  this.props.response.product !== null &&
                  this.props.response.product !== '' &&
                  Array.isArray(Object.keys(this.props.response.product)) &&
                  Object.keys(this.props.response.product).length > 0 ? (
                    <div style={{ marginTop: '10px' }}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Quantity</TableCell>
                            <TableCell>Unit Price</TableCell>
                            <TableCell>Total Price</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {Object.keys(this.props.response.product).map(key => {
                            return (
                              <TableRow key={key}>
                                <TableCell>
                                  {
                                    this.props.response.product[key].properties
                                      .name.value
                                  }
                                </TableCell>
                                <TableCell>
                                  {
                                    this.props.response.product[key].properties
                                      .quantity.value
                                  }
                                </TableCell>
                                <TableCell>
                                  {
                                    this.props.response.product[key].properties
                                      .price.value
                                  }
                                </TableCell>
                                <TableCell>
                                  {
                                    this.props.response.product[key].properties
                                      .amount.value
                                  }
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </div>
                  ) : (
                    <span style={{ marginLeft: '10px' }}>-</span>
                  )}
                </div>
                <Grid container xs={12}>
                  <Divider style={{ width: '100%', margin: '20px 0px' }} />
                </Grid>
                {this.props.response !== undefined &&
                this.props.response !== null &&
                this.props.response !== '' &&
                this.props.response.type !== 'Disqualified' ? (
                  <Grid container xs={12}>
                    <Grid item xs={11}>
                      <h4>Task Details</h4>
                    </Grid>
                    <Grid item xs={11}>
                      <Grid item xs={6} style={{ marginTop: '10px' }}>
                        <TextField
                          required
                          label="Subject"
                          value={this.state.taskSubject}
                          name="taskSubject"
                          className={classes.textField}
                          fullWidth
                          onChange={this.handleTextfieldChange}
                          disabled={this.props.hsFormValidation}
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={11}>
                      <Grid item xs={6} style={{ marginTop: '10px' }}>
                        <TextField
                          required
                          label="Task Details"
                          value={this.state.taskDetails}
                          name="taskDetails"
                          className={classes.textField}
                          fullWidth
                          multiline={true}
                          rows="3"
                          onChange={this.handleTextfieldChange}
                          disabled={this.props.hsFormValidation}
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={11}>
                      <Grid
                        item
                        xs={6}
                        style={{ marginTop: '10px', marginBottom: '10px' }}
                      >
                        <FormControl style={{ width: '100%' }}>
                          <InputLabel>Task Status</InputLabel>
                          <Select
                            required
                            label="Task Status"
                            fullWidth
                            onChange={this.handleTextfieldChange}
                            value={this.state.taskStatus}
                            className={classes.textField}
                            inputProps={{
                              id: 'taskStatus',
                              name: 'taskStatus',
                            }}
                            disabled={this.props.hsFormValidation}
                          >
                            {this.state.statusList !== undefined &&
                              this.state.statusList.length > 0 &&
                              this.state.statusList.map(function(elem, i) {
                                return (
                                  <MenuItem
                                    value={elem.key}
                                    key={`status_${i}`}
                                  >
                                    {elem.value}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid item xs={11}>
                      <Grid item xs={6} style={{ marginTop: '10px' }}>
                        <KeyboardDatePicker
                          fullWidth
                          variant="inline"
                          format={'MM/DD/YYYY'}
                          id="taskDate"
                          label="Due Date"
                          value={this.state.taskDate}
                          onChange={this.handleDateChange}
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                          disabled={this.props.hsFormValidation}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null}
                <Grid container xs={12} style={{ marginTop: '30px' }}>
                  {this.props.response !== undefined &&
                  this.props.response !== null &&
                  this.props.response !== '' &&
                  this.props.response.type == 'Not connected' ? (
                    <Button
                      disabled={this.props.hsFormValidation}
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      onClick={() => this.createHSLead()}
                    >
                      Create Lead
                    </Button>
                  ) : this.props.response !== undefined &&
                    this.props.response !== null &&
                    this.props.response !== '' &&
                    this.props.response.type !== 'Disqualified' ? (
                    <Button
                      disabled={this.props.hsFormValidation}
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      onClick={() => this.addHSTask()}
                    >
                      Submit Task
                    </Button>
                  ) : null}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Dialog>
    );
  }
}

export default withStyles(useStyles)(HSProfilePopover);
